import { useGlobalScriptsAction } from 'hooks/useGlobalScriptsAction';

export const GlobalScriptAction = () => {
  useGlobalScriptsAction();

  return null;
};

GlobalScriptAction.displayName = 'GlobalScriptAction';
